import clsx from 'clsx'
import React from 'react'

import { Tab } from '@headlessui/react'

import useResponsive from 'utils/useResponsive'

const TabSolution = ({ categories }) => {
  const { lg } = useResponsive()
  return Object.values(categories).map((category) => {
    // const { icon: Icon } = categories[category]
    const { tab: TabManuva, id } = category
    return (
      <Tab
        key={category}
        className={({ selected }) =>
          clsx(
            'flex justify-center items-center w-[100px] lg:w-fit rounded-[40px] px-[16px] py-3.5 lg:px-7 text-base lg:text-lg font-normal leading-[150%]',
            selected
              ? 'text-white bg-[#003DA6] font-medium'
              : 'text-[#92969F] hover:bg-[#003DA6]/[0.5] hover:text-white'
          )
        }
      >
        {({ selected }) => (
          <div className="flex items-center gap-x-[10px]">
            {lg
              ? (
                <TabManuva isSelected={selected}/>
              )
              : (
                <p className="uppercase text-sm font-normal leading-[160%]">{id}</p>
              )
            }
          </div>
        )}
      </Tab>
    )
  })
}

export default TabSolution
